import React from 'react';
import { Flex, Text } from '@podiumhq/design-system';

import noResultsImage from '../../images/no-results-magnifying-glass.svg';

import { GoogleAutocompleteOpenManualFormLink } from './GoogleAutocompleteOpenManualFormLink';
import { googleAutocompleteNoSearchResultsTitleStyles } from './styles';

export const GoogleAutocompleteNoResults = ({
  handleShowManualForm,
  manualFormLinkSize = null,
  image = noResultsImage,
  imageAlt = 'no search results',
  title = 'Can’t find your business?',
  enterManuallyText,
  enterManuallyButtonProps,
  ...wrapperProps
}) => (
  <Flex
    align="center"
    direction="column"
    justify="center"
    padding="30px 0 50px 0"
    {...wrapperProps}
  >
    {image && <img src={image} alt={imageAlt} />}

    {title && (
      <Text {...googleAutocompleteNoSearchResultsTitleStyles}>{title}</Text>
    )}

    {handleShowManualForm && (
      <GoogleAutocompleteOpenManualFormLink
        handleShowManualForm={handleShowManualForm}
        size={manualFormLinkSize}
        title={enterManuallyText}
        buttonProps={enterManuallyButtonProps}
      />
    )}
  </Flex>
);
